// ═══════════════════════════════════════════════════════════════════
//  composants/StatCle.js
//  StatCle
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../socle/theme";

export function StatCle({ icon, label, value, sub }) {
  return (
    <div style={{ flex: "1 1 120px", minWidth: 120, textAlign: "center", padding: "8px 6px" }}>
      <div style={{ fontSize: 22, marginBottom: 6 }}>{icon}</div>
      <div style={{ color: THEME.textMuted, fontSize: 10, textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 6, minHeight: 24 }}>{label}</div>
      <div style={{ color: THEME.gold, fontSize: 20, fontWeight: 800 }}>{value}</div>
      {sub && <div style={{ color: THEME.textDim, fontSize: 10, marginTop: 4 }}>{sub}</div>}
    </div>
  );
}
